import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import TableRow from '@mui/material/TableRow';

const StyledTableRow = styled(TableRow)`
  ${ComponentStyles}
`;

StyledTableRow.propTypes = {
  theme: PropTypes.object
};

export default StyledTableRow;
